export default __webpack_public_path__ + "static/media/bg-stream-a-1.35144ef9.png";